import { Box, Link } from '@mui/material';
import BuildBadge from './BuildBadge';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        borderTop: '1px solid #eee',
        py: 3,
        px: 2,
        backgroundColor: '#faf7f0',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 1.5,
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', sm: 'center' },
      }}
    >
      <Box display="flex" alignItems="center" gap={1.25} flexWrap="wrap">
        <BuildBadge />
      </Box>
      <Box display="flex" gap={2} flexWrap="wrap">
        <Link href="/sobre" underline="hover">
          Sobre nós
        </Link>
        <Link href="/privacy" underline="hover">
          Privacidade
        </Link>
        <Link href="/terms" underline="hover">
          Termos de uso
        </Link>
        <Link href="/contact" underline="hover">
          Contato
        </Link>
      </Box>
    </Box>
  );
};

export default Footer;
